import { render, staticRenderFns } from "./quickView.vue?vue&type=template&id=b137c4c6&"
import script from "./quickView.vue?vue&type=script&lang=js&"
export * from "./quickView.vue?vue&type=script&lang=js&"
import style0 from "./quickView.vue?vue&type=style&index=0&id=b137c4c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports